<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <!-- 表单信息 -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="bus-formData"
          label-position="top"
        >
          <div class="formContent">
            <div class="main-title">{{ id == 0 ? "新建抬头" : "修改抬头" }}</div>
            <el-row>
              <el-col :xl="8" :lg="8">
                <el-form-item label="发票类型" prop="type">
                  <el-select
                    class="form_item"
                    disabled
                    v-model="ruleForm.invoice_type"
                    placeholder="请选择发票类型"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8">
                <el-form-item label="抬头类型" prop="header_type">
                  <el-select
                    class="form_item"
                    v-model="ruleForm.header_type"
                    placeholder="请选择抬头类型"
                  >
                    <el-option
                      v-for="item in headerOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8">
                <el-form-item label="发票抬头名称" prop="header">
                  <el-input
                    v-model="ruleForm.header"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" v-if="ruleForm.header_type == 1">
                <el-form-item label="纳税人识别号" prop="identification_code">
                  <el-input
                    v-model="ruleForm.identification_code"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8" v-if="ruleForm.invoice_type != 3">
                <el-form-item label="手机号" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xl="8" :lg="8">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="ruleForm.email"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xl="8"
                :lg="8"
                v-if="ruleForm.header_type == 1 && ruleForm.invoice_type != 3"
              >
                <el-form-item label="开户银行" prop="bank">
                  <el-input
                    v-model="ruleForm.bank"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xl="8"
                :lg="8"
                v-if="ruleForm.header_type == 1 && ruleForm.invoice_type != 3"
              >
                <el-form-item label="银行账号" prop="bank_account">
                  <el-input
                    v-model="ruleForm.bank_account"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xl="8"
                :lg="8"
                v-if="ruleForm.header_type == 1 && ruleForm.invoice_type != 3"
              >
                <el-form-item label="单位地址" prop="address">
                  <el-input
                    v-model="ruleForm.address"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xl="8"
                :lg="8"
                v-if="ruleForm.header_type == 1 && ruleForm.invoice_type != 3"
              >
                <el-form-item label="单位电话" prop="telephone">
                  <el-input
                    v-model="ruleForm.telephone"
                    placeholder="请填写"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="bus-btn">
          <button class="btn" @click="submitForm('ruleForm')">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  invoiceHeaderAdd,
  invoiceHeaderEdit,
  invoiceHeaderDetail,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  data() {
    return {
      id: 0,
      active: 1,
      loading: false,
      headerOptions: [
        {
          label: "企业单位",
          value: 1,
        },
        {
          label: "个人/非企业单位",
          value: 2,
        },
      ],
      typeOptions: [
        {
          label: "全国性社会团体会费统一票据",
          value: 3,
        },
        {
          label: "普通发票",
          value: 1,
        },
        {
          label: "专用发票",
          value: 2,
        },
      ],
      type: JSON.parse(localStorage.getItem("userdata")).type,
      ruleForm: {
        header_type: 1,
        invoice_type: 3,
        header: "",
        identification_code: "",
        phone: "",
        email: "",
        bank: "",
        bank_account: "",
        address: "",
        telephone: "",
        is_default: "0",
      },
      rules: {
        invoice_type: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        header_type: [
          { required: true, message: "请选择抬头类型", trigger: "change" },
        ],
        header: [{ required: true, message: "请填写发票抬头名称", trigger: "blur" }],
        identification_code: [{ required: true, message: "请填写纳税人识别号", trigger: "blur" }],
        email: [
          { required: true, message: "请填写", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      mark: "",
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/PaymentManagement";
    });

    this.active = index;
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail(this.id);
    }else{
      this.id = 0;
    }
    this.mark = this.$route.query.mark;
  },
  created() {},
  watch: {},
  methods: {
    //24.11.23 获取详情 dxm
    getDetail(id) {
      this.loading = true;
      let userdata = JSON.parse(localStorage.getItem("userdata"))
      invoiceHeaderDetail(this.$qs.stringify({ id:id,type:userdata.type }))
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.ruleForm = res.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("提交");
          this.submitInfo();
        } else {
          return false;
        }
      });
    },
    //提交审核
    submitInfo() {
      this.loading = true;
      let data = this.ruleForm;
      data.mark = this.mark;
      data.type = this.type;
      if (this.id > 0) {
        //修改
        this.editData(data);
      } else {
        //新增
        this.addData(data);
      }
    },
    //新增
    addData(data) {
      invoiceHeaderAdd(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$message.success("添加成功！");
            // 返回上一页
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //编辑
    editData(data) {
      invoiceHeaderEdit(data)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$message.success("修改成功！");
            // 返回上一页
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  margin-top: 10px;
}
.mztitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7f8fa4;
  padding-top: 20px;
}
.content {
  padding-bottom: 40px;
  .formContent {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .main-title {
    margin: 30px 0 0;
    padding-bottom: 18px;
    border-bottom: 1px solid #f0f2f5;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #354052;
  }
  .bus-formData {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .el-row {
      width: 100%;
    }
    .el-form-item {
      width: 96%;
      margin-right: 60px;
      .el-select,
      .el-cascader {
        width: 100%;
      }
      .select {
        color: #1677ff;
        border-color: #1677ff;
      }
      .el-textarea__inner {
        border-radius: 9px;
      }
    }
  }
}
.bus-btn {
  margin-top: 80px;
  text-align: center;
  .el-button {
    position: inherit;
    transform: translateX(0);
  }
  .save-draft {
    color: #2690e6;
    background: #fff;
    border: 1px solid #008dff;
  }
}
</style>
<style lang="scss">
@media only screen and (max-width: 767px) {
}
</style>